import React from 'react'
import { Link } from 'gatsby'
// import { GatsbyImage } from 'gatsby-plugin-image'
import { getTwitterHandle, getTwitterUrl } from 'theme/utils/social-helpers'

export const SessionSpeakerCard = ({ speakerObj }) => {
  const position = speakerObj.data
  const speaker = position.Person[0].data
  const speakerName = speaker.Person_First + ' ' + speaker.Person_Last
  const speakerLink = '/profile/' + speaker.Person_Url_Slug
  const speakerCompany = position.Company && position.Company[0] && position.Company[0].data
  const speakerImage = speaker.Profile_Picture_Url_50
  return (
    <div className="p-3 w-full border border-gray-200 flex items-center mt-3">
      {speakerImage && (
        <Link to={speakerLink}>
          {/* <GatsbyImage image={speakerImage} alt={speakerName} className="w-12 h-12 mr-2 rounded" /> */}
          <img
            src={speakerImage}
            alt={speakerName}
            className="w-12 h-12 mr-2 rounded bg-gradient-to-r from-blue-200 to-violet-100"
          />
        </Link>
      )}
      <div className="flex flex-wrap justify-between w-60 sm:w-full items-end">
        <div className="flex flex-wrap items-center">
          <p className="sm:inline-flex">
            <Link to={speakerLink} className="text-gray-600 max-w-xs truncate mr-1">
              {speakerName},{' '}
            </Link>
            <span className="italic text-gray-500 sm:truncate break-words mr-1 max-w-sm">
              {position.Person_Job_Title}
              {speakerCompany && <>,</>}
            </span>
            {speakerCompany && speakerCompany.Company_Url && (
              <a href={speakerCompany.Company_Url} target="_blank" rel="noreferrer noopener">
                <span className="font-bold text-gray-600 max-w-xs truncate">
                  {speakerCompany.Company_Name.trim()}
                </span>
              </a>
            )}
            {speakerCompany && !speakerCompany.Company_Url && (
              <>
                <span className="font-bold text-gray-600 max-w-xs truncate">
                  {speakerCompany.Company_Name.trim()}
                </span>
              </>
            )}
            {speaker.Person_Linkedin && (
              <a
                className="inline-flex  align-bottom"
                target="blank"
                rel="noreferrer noopener"
                href={speaker.Person_Linkedin}
              >
                <svg className="h-6 w-6 mt-1 ml-3" fill="#2867B2" viewBox="0 0 24 24">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10,0.4c-5.302,0-9.6,4.298-9.6,9.6s4.298,9.6,9.6,9.6s9.6-4.298,9.6-9.6S15.302,0.4,10,0.4z M7.65,13.979 H5.706V7.723H7.65V13.979z M6.666,6.955c-0.614,0-1.011-0.435-1.011-0.973c0-0.549,0.409-0.971,1.036-0.971s1.011,0.422,1.023,0.971 C7.714,6.52,7.318,6.955,6.666,6.955z M14.75,13.979h-1.944v-3.467c0-0.807-0.282-1.355-0.985-1.355 c-0.537,0-0.856,0.371-0.997,0.728c-0.052,0.127-0.065,0.307-0.065,0.486v3.607H8.814v-4.26c0-0.781-0.025-1.434-0.051-1.996h1.689 l0.089,0.869h0.039c0.256-0.408,0.883-1.01,1.932-1.01c1.279,0,2.238,0.857,2.238,2.699V13.979z"
                  />
                </svg>
              </a>
            )}
          </p>
        </div>
        <div className="flex flex-wrap">
          {speaker.Person_Twitter && (
            <a
              target="blank"
              rel="noreferrer nofollow"
              href={getTwitterUrl(speaker.Person_Twitter)}
              className="flex"
            >
              <svg className="h-6 w-6" fill="#1DA1F2" viewBox="0 0 24 24">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
              </svg>
              {getTwitterHandle(speaker.Person_Twitter)}
            </a>
          )}
          {speakerCompany && speakerCompany.Company_Twitter && (
            <a
              target="blank"
              rel="noreferrer nofollow"
              href={getTwitterUrl(speakerCompany.Company_Twitter)}
              className="flex ml-2"
            >
              <svg className="h-6 w-6" fill="#1DA1F2" viewBox="0 0 24 24">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
              </svg>
              {getTwitterHandle(speakerCompany.Company_Twitter)}
            </a>
          )}
        </div>
      </div>
    </div>
  )
}

// export const RelatedSessionSpeakerCard = ({ speakerObj }) => {
//   const position = speakerObj.data
//   const speaker = position.data?.Person?.[0]?.data
//   const speakerName = speaker?.Person_First + ' ' + speaker.Person_Last
//   const speakerCompany = position.Company && position.Company[0] && position.Company[0].data
//   const speakerImage = speaker.Profile_Picture_Url_50
//   return (
//     <div className="w-full flex items-center mt-3 text-sm">
//       {speakerImage && (
//         // <GatsbyImage image={speakerImage} alt={speakerName} className="w-12 h-12 mr-3 rounded" />
//         <img
//           src={speakerImage}
//           alt={speakerName}
//           className="w-12 h-12 mr-3 rounded bg-gradient-to-r from-blue-200 to-violet-100"
//         />
//       )}
//       <div className="flex flex-wrap justify-between w-full items-end">
//         <p className="text-gray-600 w-full">{speakerName}</p>
//         <p className="italic text-gray-500">
//           {position.Person_Job_Title}
//           {speakerCompany && <span className="font-bold text-gray-600">, {speakerCompany.Company_Name}</span>}
//         </p>
//       </div>
//     </div>
//   )
// }
